export const getAddress = (state) => state.address

export const getRiskDataValidation = (state) =>
  state.validation.riskDataCollectionPage
